import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types/AppState";
import { userVerified } from "../actions";
import { localStateSelector } from "../selectors";
import { type Purchase } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const moduleApiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const apiInfo = moduleApiInfoSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfo,
      package: localState.package!,
      trial: localState.trial
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  next: (data: Purchase.View.FirstStepFormData, result: Purchase.Api.VerifyUserResponse) => {
    dispatch(userVerified(props, data, result));
  }
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
